// extracted by mini-css-extract-plugin
export default {"root":"pKmLhQZiQoEGZisuZXBY","icon":"itpYuMW_nSP2iij1Ceni","message":"PCBa1bAasWm9AAsoKmsA itpYuMW_nSP2iij1Ceni"};